module.exports = __webpack_public_path__ + "static/media/icon-series.852cc13e.svg";